import React from 'react';
import './UserActiv.css'; 
import { useSelector, useDispatch } from 'react-redux' 
import { getUserActivity, getUserID } from '../../../store/api'
import { ModalContainer } from '../../atoms' 
import { CounterPage, Search } from '../../organisms';
import { Active } from '../' 
import { configConsumerProps } from 'antd/lib/config-provider';

export function UserActiv(props) {  
  const { userActiv, totalCount } = useSelector(state => state.users)
  const [title, setTitle] = React.useState('')
  const dispatch = useDispatch()
  const limit = 20
  const allPages = Math.ceil(totalCount/limit)
  const pages = Array.from({length: allPages}, (_, i) => i + 1)
  const [inputTimer, setInputTimer] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1) 
  const [sort, setSort] = React.useState('login')
  const [isOpen, setIsOpen] = React.useState(false)
   const [id, setId] = React.useState('')
  const parametrSearch = {
    currentPage: currentPage,
    limit: limit, 
    sort: sort,
    userId: title || ''
  } 

  React.useEffect(()=> { 
    if(currentPage && sort) {  
      console.log('click')
      dispatch(getUserActivity(parametrSearch))
    } 
  },[currentPage, sort])

  React.useEffect(() => { 
    if (title) {
      console.log('click2')
        clearTimeout(inputTimer);
        let timeout = setTimeout(() => { 
            parametrSearch.searchWords = title;
            dispatch(getUserActivity(parametrSearch));
        }, 1000);
        setInputTimer(timeout);
    }
    return () => clearTimeout(inputTimer)
  }, [title]);

   
 

  function handleLogin(data) { 
    setSort(data)
  }

  function handleOpenModal(id) {
    setIsOpen(true)
    setId(id)
  }

   //Счетчик изменения страниц
 function handleCounter(page) { 
  setCurrentPage(page)
}

    //Слушатель на ввод поисковых слов
    function handleChangeInput(e) {
      setCurrentPage(1)
      setTitle(e.target.value)   
    }
 
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');  // Получаем день
      const month = String(date.getMonth() + 1).padStart(2, '0');  // Получаем месяц (месяцы начинаются с 0)
      const year = date.getFullYear();  // Получаем год
  
      return `${day}.${month}.${year}`;  // Форматируем дату в нужный формат
  };

   const handleUserActive = () => { 
      dispatch(getUserID(title))
    }
  function hanleClose () {
  setIsOpen(false) 
}
  return (
    <main className='content'>
      <Search onSearch={handleChangeInput} keyword={title} placeholder='Искать по id'/>
      <button className='my-recipe__add-button' onClick={handleUserActive}>Найти пользователя</button> 
        <div className='table__thead'>
        <ul className='activ'>
          <li className='activ_id'>userId</li>  
          <li className='activ_item'>ЛОГИН <span onClick={()=>handleLogin('login')} className='gg-sort'></span></li>
          <li className='activ_item'>ВИЗИТ <span onClick={()=>handleLogin('visit')}  className='gg-sort'></span></li> 
          <li className='activ_item'>ПОИСК<span  onClick={()=>handleLogin('search')} className='gg-sort'></span></li>
          <li className='activ_item'>dfoodlist <span  onClick={()=>handleLogin('dfoodlist')} className='gg-sort'></span></li> 
          <li className='activ_item'>dplan <span  onClick={()=>handleLogin('dplan')} className='gg-sort'></span></li> 
          <li className='activ_item'>foodlist <span  onClick={()=>handleLogin('foodlist')} className='gg-sort'></span></li>
          <li className='activ_item'>gener <span  onClick={()=>handleLogin('gener')} className='gg-sort'></span></li>
          <li className='activ_item'>settings <span onClick={()=>handleLogin('settings')}  className='gg-sort'></span></li> 
          <li className='activ_item'>upplan <span  onClick={()=>handleLogin('upplan')} className='gg-sort'></span></li>
          <li className='activ_item'>reset <span  onClick={()=>handleLogin('reset')} className='gg-sort'></span></li>
          <li className='activ_data'>Дата1 <span  onClick={()=>handleLogin('firstTime')} className='gg-sort'></span></li>
          <li className='activ_data'>Дата2 <span  onClick={()=>handleLogin('lastTime')} className='gg-sort'></span></li>

        </ul>
      </div>
      {userActiv.length > 0 &&
        userActiv.map((i, index)=> (
          <ul key={index} className='activ'>
          <li className='activ_id item__link' onClick={()=>handleOpenModal(i._id)}>{i._id}</li> 
          <li className='activ_item'> {i.login}</li>
          <li className='activ_item'> {i.visit}</li> 
          <li className='activ_item'>{i.search}</li>
          <li className='activ_item'>{i.dfoodlist}</li> 
          <li className='activ_item'>{i.dplan}</li> 
          <li className='activ_item'>{i.foodlist}</li>
          <li className='activ_item'>{i.gener}</li>
          <li className='activ_item'>{i.settings}</li> 
          <li className='activ_item'>{i.upplan}</li>
          <li className='activ_item'>{i.reset}</li>
          <li className='activ_data'>{formatDate(i.firstTime)}</li> 
          <li className='activ_data'>{formatDate(i.lastTime)}</li>
            
          </ul>
      ))}
      <div className='pages'>
         <CounterPage handleCounter={handleCounter} pages={pages} currentPage={currentPage} totalCount={totalCount}/>
        </div>

      {  isOpen && 
        <ModalContainer 
          isOpen={isOpen}
          onClose={hanleClose}
          title='monitoring'
        > 
          <Active id={id} /> 
        </ModalContainer>
      }
    </main>
)
   
}
